import { PackagingOrderType, PackagingOrderStatus } from '@/types/packaging'

export const packagingOrderTypes: Record<string, string> = {
    [PackagingOrderType.Delivery]: 'delivery',
    [PackagingOrderType.Pickup]: 'pickup',
}

export const packagingOrderStatus: Record<string, string> = {
    [PackagingOrderStatus.Created]: 'created',
    [PackagingOrderStatus.Accepted]: 'accepted',
    [PackagingOrderStatus.Finished]: 'finished',
    [PackagingOrderStatus.Canceled]: 'canceled',
}
